// extracted by mini-css-extract-plugin
export default {"expenseViewWrapper":"ExpenseView_expenseViewWrapper__-udJj"};